import { Children, cloneElement } from "react";
import { useInView } from "react-intersection-observer";
import cx from "classnames";
import PropTypes from "prop-types";

const AnimateOnScroll = ({
  animation,
  children,
  style,
  threshold,
  triggerOnce = true,
}) => {
  const { ref, inView } = useInView({
    triggerOnce,
    threshold,
  });

  const modifyChild = (child) => {
    const className = cx(child.props.className, animation, {
      "animation-active": inView,
    });
    const props = {
      ...child.props,
      style: { ...child.props.style, ...style },
      className,
      ref,
    };
    return cloneElement(child, props);
  };

  if (!animation) {
    return children;
  }

  return Children.only(children) && modifyChild(children);
};

AnimateOnScroll.propTypes = {
  animation: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  children: PropTypes.element.isRequired,
  style: PropTypes.object,
  threshold: PropTypes.number,
  triggerOnce: PropTypes.bool,
};

export default AnimateOnScroll;
